import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f5cdae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contenedor_principal",
  class: "col-12 md:col-10 lg:col-8 xl:col-6 md:col-offset-1 lg:col-offset-2 xl:col-offset-3"
}
const _hoisted_2 = {
  id: "contenedor",
  class: "border-round"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_6 = {
  id: "dv_button",
  class: "text-right"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Ingresar", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-12 lg:col-12 xl:col-6 xl:col-offset-3" }, null, -1))
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = {
  id: "dv_logo_100",
  class: "slider-wrapper"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { id: "td_logo_100" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "container-transition",
      style: _normalizeStyle({ 'background-image': 'url(' + _ctx.imagen + ')' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.presentacion !== null)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.presentacion.titulo), 1))
            : _createCommentVNode("", true),
          (_ctx.presentacion !== null)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.presentacion.subtitulo), 1))
            : _createCommentVNode("", true),
          (_ctx.presentacion !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentacion.notas, (nota, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(nota), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "p-button p-button-primary p-3 border-round",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.VerDifusion && _ctx.VerDifusion(...args)))
            }, _hoisted_8)
          ])
        ]),
        _hoisted_9
      ])
    ], 4),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr_imagesJson, (nodo, indice) => {
          return (_openBlock(), _createElementBlock("a", {
            key: indice,
            href: nodo.Url_destino,
            target: "_blank",
            class: "slider-item"
          }, [
            _createElementVNode("img", {
              src: nodo.Imagen,
              alt: nodo.Titulo
            }, null, 8, _hoisted_13)
          ], 8, _hoisted_12))
        }), 128))
      ]),
      _createElementVNode("table", _hoisted_14, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr_imagesJson, (nodo, indice) => {
            return (_openBlock(), _createElementBlock("td", { key: indice }, [
              _createElementVNode("a", {
                href: nodo.Url_destino,
                target: "_blank",
                class: "slider-item"
              }, [
                _createElementVNode("img", {
                  src: nodo.Imagen,
                  alt: nodo.Titulo
                }, null, 8, _hoisted_16)
              ], 8, _hoisted_15)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}